export default __webpack_public_path__ + "assets/save_big.png";